// extracted by mini-css-extract-plugin
module.exports = {"input":"ServiceFee_style_input__27jef","label":"ServiceFee_style_label__2XQkJ","hljd-input-number-input":"ServiceFee_style_hljd-input-number-input__2F-xi"};